<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="chap2">ONE</h1>
<h1 class="center">The Shades of Spring</h1>
<p class="noind" style="margin-top:30px;">Before the Sun — Down in the Dark — The Invader — Wasps at Easter — The Death of a Bike — Old Moses Comes to Call — A Summons from the Lady</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 6-chap2.vue?1e25f454